module.exports = __webpack_public_path__ + "img/bg_square.32e85740.png";